export const OC_QUOTE_REDEMPTION_DETAILS = {
  desktop: `<div class="cui-grid cui-container -spacing--top-32 -spacing--bottom-64">
  <div class="cui-row">
    <div class="cui-col-lg-12">

      <div class="cui-skeleton-paragraph -spacing--bottom-32">
        <div class="cui-skeleton-paragraph__content" style="width: 160px">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--large -spacing--bottom-32">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-32">
        <div class="cui-skeleton__item" style="width: 100%; height: 264px;"></div>
      </div>

      <div class="cui-skeleton-heading -size--medium -spacing--bottom-24">
        <div class="cui-skeleton-heading__content" >
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>

      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 80px;"></div>
      </div>
      
      <div class="cui-skeleton-paragraph -spacing--bottom-24">
        <div class="cui-skeleton-paragraph__content" style="width: 120px">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>

      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 52px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>

    </div>
  </div>
</div>`
};
